import * as IoC from 'typescript-ioc';
import { JobConfiguration } from '../../job-configuration';
import { JobType } from '../../../../api/jobs.dao';
import { IWebsiteDAO } from '../../../../api/website.dao';

export class PassportConfigurationUploadJob extends JobConfiguration {
    public readonly type = JobType.PassportSettingsUpload;
    public readonly name = 'Upload Passport Configuration';
    public readonly description = 'Configuration Upload';

    public async execute(execParams) {
        return IoC.Container.get(IWebsiteDAO).uploadConfigurationJSON(execParams);
    }
}

export default {
    [JobType.PassportSettingsUpload]: PassportConfigurationUploadJob
};
